import React from 'react';

import { flagStyles } from '../settings';

const SvgLU = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3168px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgLU;
